<div
  class="number-stepper"
  [class.number-stepper--invalid]="invalid()"
  [class.number-stepper--disabled]="disabled()"
>
  <button
    type="button"
    class="number-stepper__button"
    [attr.aria-label]="'NumberStepper.decrease' | translate"
    [disabled]="!canDecrease()"
    (click)="decrease()"
  >
    <span class="material-icons" aria-hidden="true">remove</span>
  </button>

  <input
    type="text"
    inputmode="decimal"
    class="number-stepper__input"
    [value]="text()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    (input)="onInput($any($event.target).value)"
    (blur)="onBlur()"
  />

  @if (suffix()) {
    <span class="number-stepper__suffix">{{ suffix() | translate }}</span>
  }

  <button
    type="button"
    class="number-stepper__button"
    [attr.aria-label]="'NumberStepper.increase' | translate"
    [disabled]="!canIncrease()"
    (click)="increase()"
  >
    <span class="material-icons" aria-hidden="true">add</span>
  </button>
</div>
